var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.415V6.734c0-.538.51-.893.951-.663l11.224 5.836c.513.266.513 1.069 0 1.336L7.951 19.078c-.442.23-.951-.125-.951-.663z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgPlay;